export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14411.54815ed7.jpg";